import {Link as ReactRouterLink, LinkProps as ReactRouterLinkProps} from 'react-router';
import {ComponentWithRequiredChildren} from '../react/types';
import {Link, LinkProps} from './Link';

type AllowedLinkProps = Omit<LinkProps, 'component'>;
type AllowedReactRouterLinkProps = Pick<ReactRouterLinkProps, 'reloadDocument' | 'replace' | 'state' | 'to'>;
export type RouteLinkProps = AllowedLinkProps & AllowedReactRouterLinkProps;

export const RouteLink: ComponentWithRequiredChildren<RouteLinkProps> = ({children, ...muiProps}: RouteLinkProps) => {
  return (
    <Link {...muiProps} component={ReactRouterLink}>
      {children}
    </Link>
  );
};
